import { KEG_SPOILAGE_RATE_MULTIPLIER } from '../constants.js'
import { cellarService } from '../services/cellar.js'

/**
 * @returns number
 */
export const getKegSpoilageRate = (keg: farmhand.keg) => {
  if (!cellarService.doesKegSpoil(keg) || keg.daysUntilMature > 0) {
    return 0
  }

  const spoilageRate =
    Math.abs(keg.daysUntilMature) * KEG_SPOILAGE_RATE_MULTIPLIER

  return spoilageRate
}
